import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  InputGroup,
  InputRightAddon,
  NumberInput,
  NumberInputField,
  Select,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { Option } from '../../../../../../types/Form';
import { OffersParametersFormType } from './OfferParametersForm';

interface Props {
  withContentValue?: boolean;
  evaluationSystemTypes: Option[];
}

const OfferHomeFormControls: React.FC<React.PropsWithChildren<Props>> = ({
  withContentValue,
  evaluationSystemTypes,
}) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    watch,
  } = useFormContext<OffersParametersFormType>();

  return (
    <>
      <FormControl>
        <FormLabel htmlFor="evaluationBuilding">
          {t('Evaluation type building')}
        </FormLabel>
        <Select
          placeholder={t('Choose an option')}
          {...register('evaluationBuilding')}
        >
          {evaluationSystemTypes.map(({ label, value }, index) => (
            <option key={index} value={value as string}>
              {label}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl isInvalid={!!errors.insuredValue}>
        <FormLabel htmlFor="insuredValue">{t('Insured value')}</FormLabel>
        <InputGroup>
          <Controller
            control={control}
            name="insuredValue"
            render={({ field: { ref, ...restField } }) => (
              <NumberInput
                id="insuredValue"
                precision={2}
                placeholder={t('Insured value')}
                clampValueOnBlur={false}
                isDisabled={watch('evaluationBuilding') !== 'FIRST_RISK'}
                {...restField}
              >
                <NumberInputField ref={ref} borderRightRadius="0" />
              </NumberInput>
            )}
          />
          <InputRightAddon>€</InputRightAddon>
        </InputGroup>
        {errors.insuredValue && (
          <FormErrorMessage justifyContent="flex-end">
            {errors.insuredValue.message}
          </FormErrorMessage>
        )}
      </FormControl>
      <FormControl isInvalid={!!errors.insuredContentValue}>
        <FormLabel htmlFor="insuredContentValue">
          {t('Insured content value')}
        </FormLabel>
        <InputGroup>
          <Controller
            control={control}
            name="insuredContentValue"
            render={({ field: { ref, ...restField } }) => (
              <NumberInput
                id="insuredContentValue"
                precision={2}
                placeholder={t('Insured content value')}
                clampValueOnBlur={false}
                isDisabled={!withContentValue}
                {...restField}
              >
                <NumberInputField ref={ref} borderRightRadius="0" />
              </NumberInput>
            )}
          />
          <InputRightAddon>€</InputRightAddon>
        </InputGroup>
        {errors.insuredContentValue && (
          <FormErrorMessage justifyContent="flex-end">
            {errors.insuredContentValue.message}
          </FormErrorMessage>
        )}
      </FormControl>
    </>
  );
};

export default OfferHomeFormControls;
